/**
 * molto-recherche-reference (lot 2.3, C2) - retrouve une référence produit saisie approximativement :
 *   "C1 23536"  -> C123536   (espaces internes ignorés, avec ou sans tiret)
 *   "1010449"   -> 001010449 (zéros initiaux omis)
 * Aucune tolérance aux fautes de frappe. Aucune donnée produit ni réglage d'app modifié :
 * on ne fait que réécrire la requête de recherche côté navigateur, et SEULEMENT quand la saisie d'origine
 * ne renvoie aucun produit (la recherche normale n'est jamais détournée).
 *
 * Deux points d'entrée :
 *  1. recherche prédictive (requêtes /search/suggest) : réécriture transparente de la requête ;
 *  2. page /search : si aucun produit pour la saisie, redirection vers la requête corrigée + bandeau d'information.
 */
(function () {
  'use strict';
  if (window.__moltoRechercheReference) return;
  window.__moltoRechercheReference = true;

  var origFetch = window.fetch.bind(window);
  var FIELDS = 'title,product_type,variants.title,vendor,variants.sku,variants.barcode';
  var cache = {};
  var MAX_APPELS = 6;

  function candidats(saisie) {
    var t = String(saisie || '').trim().replace(/\s+/g, ' ');
    if (!t || t.length > 40 || !/\d/.test(t)) return [];
    var bases = [];
    if (/\s/.test(t)) {
      var colle = t.replace(/\s+/g, '');
      var tiret = t.replace(/\s+/g, '-');
      if (/^[A-Za-z0-9\-\/._]{3,24}$/.test(colle)) bases.push(colle);
      if (tiret !== colle && /^[A-Za-z0-9\-\/._]{3,24}$/.test(tiret)) bases.push(tiret);
    } else {
      bases.push(t);
    }
    var out = [];
    bases.forEach(function (b) {
      if (b !== t && out.indexOf(b) < 0) out.push(b);
      if (/^\d{3,9}$/.test(b)) {                       // numérique court : zéros initiaux possibles (EAN exclus)
        for (var z = 1; z <= 4; z++) {
          var c = '0'.repeat(z) + b;
          if (c.length <= 12 && out.indexOf(c) < 0) out.push(c);
        }
      }
    });
    return out.filter(function (c) { return c !== t; }).slice(0, MAX_APPELS);
  }

  function nbProduits(q) {
    if (cache[q] !== undefined) return cache[q];
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 2500) : null;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=1' +
      '&resources[options][fields]=' + encodeURIComponent(FIELDS);
    cache[q] = origFetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var p = j && j.resources && j.resources.results && j.resources.results.products;
        return p ? p.length : -1;                       // -1 : inconnu (erreur) -> on ne touche à rien
      })
      .catch(function () { return -1; })
      .then(function (n) { if (timer) clearTimeout(timer); return n; });
    return cache[q];
  }

  /** Requête à utiliser : la saisie telle quelle si elle donne des produits (ou en cas de doute), sinon la 1re variante qui en donne. */
  function resoudre(saisie) {
    var liste = candidats(saisie);
    if (!liste.length) return Promise.resolve(saisie);
    return nbProduits(saisie).then(function (n) {
      if (n !== 0) return saisie;
      var i = 0;
      function suivant() {
        if (i >= liste.length) return saisie;
        var c = liste[i++];
        return nbProduits(c).then(function (m) { return m > 0 ? c : suivant(); });
      }
      return suivant();
    });
  }

  // 1. recherche prédictive
  window.fetch = function (input, init) {
    try {
      var href = typeof input === 'string' ? input : (input && input.url) || String(input);
      var u = new URL(href, location.origin);
      if (/\/search\/suggest$/.test(u.pathname) && u.searchParams.has('q')) {
        var q = u.searchParams.get('q');
        if (candidats(q).length) {
          return resoudre(q).then(function (q2) {
            if (q2 === q) return origFetch(input, init);
            u.searchParams.set('q', q2);
            return origFetch(typeof input === 'string' ? u.toString() : new Request(u.toString(), input), init);
          });
        }
      }
    } catch (e) { /* en cas de souci on laisse passer la requête d'origine */ }
    return origFetch(input, init);
  };

  // 2. page de résultats
  function pageRecherche() {
    if (!/\/search\/?$/.test(location.pathname)) return;
    var u = new URL(location.href);
    var q = u.searchParams.get('q');
    var origine = u.searchParams.get('molto_q');
    if (origine) { bandeau(origine, q); return; }
    if (!q || !candidats(q).length) return;
    resoudre(q).then(function (q2) {
      if (q2 && q2 !== q) {
        u.searchParams.set('q', q2);
        u.searchParams.set('molto_q', q);
        location.replace(u.toString());
      }
    });
  }

  function bandeau(origine, corrigee) {
    function poser() {
      var main = document.querySelector('main') || document.body;
      if (!main || document.getElementById('molto-recherche-info')) return;
      var p = document.createElement('p');
      p.id = 'molto-recherche-info';
      p.setAttribute('role', 'status');
      p.style.cssText = 'margin:0;padding:0.75rem 1rem;font-size:0.9rem;text-align:center;';
      p.textContent = 'Aucun produit pour « ' + origine + ' » : résultats pour la référence « ' + corrigee + ' ».';
      main.insertBefore(p, main.firstChild);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poser); else poser();
  }

  pageRecherche();
})();
